import { JobAction } from '~~/interface/Job';

import { child, set } from 'firebase/database';
import { PiniaPluginContext } from 'pinia'
import { RunMode } from "~~/interface/Pos";

const PrinterJob = ThermalPrinterJob


function MyPiniaPlugin({ store }: PiniaPluginContext) {



  if (store.$id == 'jobs') {
    // jobs from my machine sync to cloud
    store.$onAction((action) => {
      let job = action.args[0];
      let syncToCloud = action.args[1];
      let runMode = useRunningMode().getMode();
      
      // โหมด Audit ดูอย่างเดียว — jobs.add บล็อก job ไว้แล้ว แต่ $onAction ยิงก่อนตัว action
      // ต้องกันไม่ให้พิมพ์ใบที่ไม่มีวันเกิดขึ้นจริง
      if (action.name == 'add' && syncToCloud && job.print && !isAuditMode()) {     
        if(runMode !== RunMode.CASHIER_2ND){
          printJob(job)
        }else{    
          if(job.action !== JobAction.ADD){
            printJob(job)
          }     
        }  
         
      }
      if (action.name == 'rePrint'   ) {       
        rePrintJob(job)
      }
    })
  }


  if (store.$id == 'receipts') {
    // jobs from my machine sync to cloud
    store.$onAction((action) => {
      let receipt = action.args[0];
      let syncToCloud = action.args[1];
      if (action.name == 'add' && syncToCloud  ) {
        printReceipt(receipt)
      }
    })
  }

  

}

export default defineNuxtPlugin(({ $pinia }) => {
  $pinia.use(MyPiniaPlugin)
})



function printJob(job) {
   
  let printerService = new PrinterService()
  switch (job.action) {
    case JobAction.ADD:      
      new PrinterJob().printCustomMode(job, printerService).withForwardZone(job).print()
      //new PrinterJob().printOneByOne(job, printerService) .print()
      break;
    case JobAction.MOVE:
      new PrinterJob().printMoveItems(job, printerService) .print()
      break;

    case JobAction.VOID:
      new PrinterJob().printVoidCustom(job, printerService) .print()
      break;  

    default:
      break;
  }
}

function rePrintJob(job) {
   
  let printerService = new PrinterService()
  switch (job.action) {
    case JobAction.REPRINT:
      new PrinterJob().rePrintJob(job, printerService) .print()
      break;

    default:
      break;
  }
}


function printReceipt(receipt) { 
}

function printDashboard(payload) {

}
